import { experiences } from '../../data/experience';
import { ui } from '../../data/ui';
import { SectionHeader } from '../ui/SectionHeader';
import { TimelineItem } from '../ui/TimelineItem';
import { Button } from '../ui/Button';
import './Experience.css';

export function ExperienceSection() {
  const previewExperiences = experiences.slice(-2);

  return (
    <section className="section experience-section" id="experience">
      <div className="container">
        <SectionHeader
          label={ui.sections.career}
          title={ui.sections.professionalJourney}
          subtitle={ui.sections.professionalJourneySub}
        />

        <div className="timeline">
          {previewExperiences.map((exp, i) => (
            <TimelineItem
              key={exp.id}
              experience={exp}
              index={i}
              isLast={i === previewExperiences.length - 1}
            />
          ))}
        </div>

        <div className="section-cta">
          <Button to="/experience" variant="ghost">
            {ui.sections.viewFullExperience} <span className="arrow">←</span>
          </Button>
        </div>
      </div>
    </section>
  );
}
